// refactor sass to stylejs (no theme usage)
import { css } from '@emotion/react';
import { styled } from '@mui/material/styles';

export const StyledUiMenu = styled('div')(
  () => css`
    #mui-menu-button {
      .icon {
        width: 40px;
        height: 40px;
        justify-content: center;
        cursor: pointer;
        border-radius: 6px;

        &:hover {
          background-color: rgba(25, 157, 163, 0.03);
        }
      }
    }
  `
);
